import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  usePermissions,
  useNotify,
} from "react-admin";

const CourseEdit = (props) => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();

  if (
    !(
      permissions.includes("user-guides.edit") ||
      permissions.includes("user-guides.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  return (
    <Edit title="Edit Course" {...props} redirect="list">
      <SimpleForm
        onSuccess={() =>
          notify("Course updated successfully", { type: "success" })
        }
      >
        <TextInput source="course_name" />
        <TextInput source="description" multiline />
        <BooleanInput source="is_active" />
      </SimpleForm>
    </Edit>
  );
};

export default CourseEdit;